import { batch, useSignal } from "@preact/signals-react"
import { alertsDrawerData } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"
import { useCallback } from "react"

export default function useAlertsDataInfo(value) {

	const dataInfo = useSignal(value)

	const setDataInfo = useCallback((value, key) => batch(() => {
		dataInfo.value = value
		alertsDrawerData.value = { ...alertsDrawerData.value, [key]: value }
	}), [])

	return {
		dataInfo, setDataInfo,
	}
}
